/**
 * Color tokens for the Western Express prototype.
 *
 * Dark zinc surfaces matching the new-design palette, plus the semantic
 * accents used across the mockups (Storyboard purple for "Storyboard
 * resolved", green for "auto-resolved", red/amber for risk).
 */

export const zinc = {
  300: "#d4d4d8",
  400: "#a1a1aa",
  500: "#71717a",
  600: "#52525b",
  700: "#3f3f46",
  800: "#27272a",
  850: "#1f1f23",
  900: "#18181b",
  950: "#0d0d0f",
} as const;

export const accent = {
  /** Storyboard brand purple. */
  purple: "#9F11FE",
  purpleSoft: "rgba(159, 17, 254, 0.16)",
  purpleBorder: "rgba(159, 17, 254, 0.5)",

  green: "#22c55e",
  greenSoft: "rgba(34, 197, 94, 0.14)",
  greenBorder: "rgba(34, 197, 94, 0.45)",

  red: "#ef4444",
  redSoft: "rgba(239, 68, 68, 0.16)",
  redBorder: "rgba(239, 68, 68, 0.5)",

  amber: "#f59e0b",
  amberSoft: "rgba(245, 158, 11, 0.16)",
  amberBorder: "rgba(245, 158, 11, 0.5)",

  blue: "#3b82f6",
  blueSoft: "rgba(59, 130, 246, 0.16)",
  blueBorder: "rgba(59, 130, 246, 0.5)",
} as const;

export const traffic = {
  clear: "#22c55e",
  moderate: "#f59e0b",
  heavy: "#ef4444",
} as const;

export const text = {
  primary: "#fafafa",
  secondary: zinc[400],
  muted: zinc[500],
} as const;
